/* tslint:disable */
/* eslint-disable */
/**
 * OpenField Cloud Internal API
 * API definition for internal API endpoints. Note that routes may appear in more than one of the categories listed below.  Routes definitions are copied verbatim from the API definition of service they are routed to (such as https://github.com/SBGSports/openfield-annotations-service/blob/main/api/openapi.yaml) with the following exceptions: - the customer_id parameter is not required on the internal API - the internal API has some additional tags (such as Importers) 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActivitiesResponse
 */
export interface ActivitiesResponse {
    /**
     * 
     * @type {Array<ActivityResponse>}
     * @memberof ActivitiesResponse
     */
    'activities'?: Array<ActivityResponse>;
}
/**
 * 
 * @export
 * @interface Activity
 */
export interface Activity {
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'id': string;
    /**
     * Name
     * @type {string}
     * @memberof Activity
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof Activity
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof Activity
     */
    'end_time_ms': number;
    /**
     * 
     * @type {Array<Period>}
     * @memberof Activity
     */
    'periods': Array<Period>;
}
/**
 * 
 * @export
 * @interface ActivityAthleteTagNameBatchItem
 */
export interface ActivityAthleteTagNameBatchItem {
    /**
     * ID of the athlete to tag within the activity
     * @type {string}
     * @memberof ActivityAthleteTagNameBatchItem
     */
    'athlete_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAthleteTagNameBatchItem
     */
    'tag_name': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAthleteTagNameBatchItem
     */
    'tag_type_name': string;
}
/**
 * 
 * @export
 * @interface ActivityBatchResponse
 */
export interface ActivityBatchResponse {
    /**
     * 
     * @type {ActivityBatchResponseOK}
     * @memberof ActivityBatchResponse
     */
    'ok'?: ActivityBatchResponseOK;
    /**
     * 
     * @type {ActivityBatchResponseError}
     * @memberof ActivityBatchResponse
     */
    'error'?: ActivityBatchResponseError;
}
/**
 * 
 * @export
 * @interface ActivityBatchResponseError
 */
export interface ActivityBatchResponseError {
    /**
     * 
     * @type {Array<ActivityError>}
     * @memberof ActivityBatchResponseError
     */
    'errors'?: Array<ActivityError>;
    /**
     * 
     * @type {Array<ActivityBatchResponseErrorPeriod>}
     * @memberof ActivityBatchResponseError
     */
    'periods'?: Array<ActivityBatchResponseErrorPeriod>;
}
/**
 * 
 * @export
 * @interface ActivityBatchResponseErrorAthlete
 */
export interface ActivityBatchResponseErrorAthlete {
    /**
     * 
     * @type {string}
     * @memberof ActivityBatchResponseErrorAthlete
     */
    'athlete_id'?: string;
    /**
     * 
     * @type {Array<AthleteError>}
     * @memberof ActivityBatchResponseErrorAthlete
     */
    'errors'?: Array<AthleteError>;
}
/**
 * 
 * @export
 * @interface ActivityBatchResponseErrorPeriod
 */
export interface ActivityBatchResponseErrorPeriod {
    /**
     * 
     * @type {string}
     * @memberof ActivityBatchResponseErrorPeriod
     */
    'id'?: string;
    /**
     * 
     * @type {Array<PeriodError>}
     * @memberof ActivityBatchResponseErrorPeriod
     */
    'errors'?: Array<PeriodError>;
    /**
     * 
     * @type {Array<ActivityBatchResponseErrorAthlete>}
     * @memberof ActivityBatchResponseErrorPeriod
     */
    'athletes'?: Array<ActivityBatchResponseErrorAthlete>;
}
/**
 * 
 * @export
 * @interface ActivityBatchResponseOK
 */
export interface ActivityBatchResponseOK {
    /**
     * 
     * @type {string}
     * @memberof ActivityBatchResponseOK
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ActivityBatchResponseOK
     */
    'start_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityBatchResponseOK
     */
    'end_time'?: number;
    /**
     * 
     * @type {Array<ActivityUpdateResponseAthleteInActivity>}
     * @memberof ActivityBatchResponseOK
     */
    'athletes'?: Array<ActivityUpdateResponseAthleteInActivity>;
    /**
     * 
     * @type {Array<ActivityUpdateResponsePeriod>}
     * @memberof ActivityBatchResponseOK
     */
    'periods': Array<ActivityUpdateResponsePeriod>;
}
/**
 * 
 * @export
 * @interface ActivityError
 */
export interface ActivityError {
    /**
     * 
     * @type {ActivityErrorCode}
     * @memberof ActivityError
     */
    'error_code'?: ActivityErrorCode;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ActivityErrorCode = {
    Little: 'duration_too_little',
    Much: 'duration_too_much'
} as const;

export type ActivityErrorCode = typeof ActivityErrorCode[keyof typeof ActivityErrorCode];


/**
 * 
 * @export
 * @interface ActivityRequest
 */
export interface ActivityRequest {
    /**
     * Name of the activity
     * @type {string}
     * @memberof ActivityRequest
     */
    'name': string;
    /**
     * ID of the venue field
     * @type {string}
     * @memberof ActivityRequest
     */
    'venue_field_id'?: string;
    /**
     * ID of the period depth type
     * @type {string}
     * @memberof ActivityRequest
     */
    'period_depth_type_id'?: string;
    /**
     * ID of the associated sport
     * @type {string}
     * @memberof ActivityRequest
     */
    'sport_id'?: string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityRequest
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityRequest
     */
    'end_time_ms': number;
    /**
     * Timezone for the activity
     * @type {string}
     * @memberof ActivityRequest
     */
    'timezone'?: string;
    /**
     * ID of the threshold set
     * @type {string}
     * @memberof ActivityRequest
     */
    'threshold_set_id'?: string | null;
}
/**
 * 
 * @export
 * @interface ActivityResponse
 */
export interface ActivityResponse {
    /**
     * 
     * @type {string}
     * @memberof ActivityResponse
     */
    'id': string;
    /**
     * Name
     * @type {string}
     * @memberof ActivityResponse
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityResponse
     */
    'start_time_ms': number;
    /**
     * Null represents started activity
     * @type {number}
     * @memberof ActivityResponse
     */
    'end_time_ms'?: number | null;
    /**
     * ID of the venue field
     * @type {string}
     * @memberof ActivityResponse
     */
    'venue_field_id'?: string;
    /**
     * ID of the period depth type
     * @type {string}
     * @memberof ActivityResponse
     */
    'period_depth_type_id'?: string;
    /**
     * ID of the associated sport
     * @type {string}
     * @memberof ActivityResponse
     */
    'sport_id'?: string;
    /**
     * ID of the threshold set
     * @type {string}
     * @memberof ActivityResponse
     */
    'threshold_set_id'?: string | null;
}
/**
 * 
 * @export
 * @interface ActivityTagNameBatchItem
 */
export interface ActivityTagNameBatchItem {
    /**
     * ID of the activity to tag
     * @type {string}
     * @memberof ActivityTagNameBatchItem
     */
    'activity_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityTagNameBatchItem
     */
    'tag_name': string;
    /**
     * 
     * @type {string}
     * @memberof ActivityTagNameBatchItem
     */
    'tag_type_name': string;
}
/**
 * 
 * @export
 * @interface ActivityUpdateBatchRequest
 */
export interface ActivityUpdateBatchRequest {
    /**
     * The list of periods.
     * @type {Array<ActivityUpdateRequestPeriod>}
     * @memberof ActivityUpdateBatchRequest
     */
    'periods'?: Array<ActivityUpdateRequestPeriod>;
}
/**
 * 
 * @export
 * @interface ActivityUpdateRequestAthlete
 */
export interface ActivityUpdateRequestAthlete {
    /**
     * The ID of the athlete.
     * @type {string}
     * @memberof ActivityUpdateRequestAthlete
     */
    'athlete_id': string;
}
/**
 * 
 * @export
 * @interface ActivityUpdateRequestPeriod
 */
export interface ActivityUpdateRequestPeriod {
    /**
     * Period ID
     * @type {string}
     * @memberof ActivityUpdateRequestPeriod
     */
    'id': string;
    /**
     * The name of the period.
     * @type {string}
     * @memberof ActivityUpdateRequestPeriod
     */
    'name': string;
    /**
     * The start time of the period in milliseconds.
     * @type {number}
     * @memberof ActivityUpdateRequestPeriod
     */
    'start_time_ms': number;
    /**
     * The end time of the period in milliseconds.
     * @type {number}
     * @memberof ActivityUpdateRequestPeriod
     */
    'end_time_ms': number;
    /**
     * 
     * @type {Array<ActivityUpdateRequestAthlete>}
     * @memberof ActivityUpdateRequestPeriod
     */
    'athletes': Array<ActivityUpdateRequestAthlete>;
}
/**
 * 
 * @export
 * @interface ActivityUpdateResponseAthleteInActivity
 */
export interface ActivityUpdateResponseAthleteInActivity {
    /**
     * ID of the athlete
     * @type {string}
     * @memberof ActivityUpdateResponseAthleteInActivity
     */
    'athlete_id'?: string;
    /**
     * ID of the activity athlete
     * @type {string}
     * @memberof ActivityUpdateResponseAthleteInActivity
     */
    'activity_athlete_id'?: string;
}
/**
 * 
 * @export
 * @interface ActivityUpdateResponseAthleteInPeriod
 */
export interface ActivityUpdateResponseAthleteInPeriod {
    /**
     * ID of the athlete
     * @type {string}
     * @memberof ActivityUpdateResponseAthleteInPeriod
     */
    'athlete_id'?: string;
    /**
     * ID of the period athlete
     * @type {string}
     * @memberof ActivityUpdateResponseAthleteInPeriod
     */
    'period_athlete_id'?: string;
    /**
     * 
     * @type {Array<ActivityUpdateResponseRotation>}
     * @memberof ActivityUpdateResponseAthleteInPeriod
     */
    'rotations'?: Array<ActivityUpdateResponseRotation>;
}
/**
 * 
 * @export
 * @interface ActivityUpdateResponsePeriod
 */
export interface ActivityUpdateResponsePeriod {
    /**
     * ID of the period
     * @type {string}
     * @memberof ActivityUpdateResponsePeriod
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityUpdateResponsePeriod
     */
    'name'?: string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityUpdateResponsePeriod
     */
    'start_time_ms'?: number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityUpdateResponsePeriod
     */
    'end_time_ms'?: number;
    /**
     * 
     * @type {Array<ActivityUpdateResponseAthleteInPeriod>}
     * @memberof ActivityUpdateResponsePeriod
     */
    'athletes'?: Array<ActivityUpdateResponseAthleteInPeriod>;
}
/**
 * 
 * @export
 * @interface ActivityUpdateResponseRotation
 */
export interface ActivityUpdateResponseRotation {
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityUpdateResponseRotation
     */
    'start_time_ms'?: number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityUpdateResponseRotation
     */
    'end_time_ms'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityUpdateResponseRotation
     */
    'number'?: number;
}
/**
 * 
 * @export
 * @interface ActivityWithRelationsResponse
 */
export interface ActivityWithRelationsResponse {
    /**
     * 
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'id': string;
    /**
     * Name
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof ActivityWithRelationsResponse
     */
    'start_time_ms': number;
    /**
     * Null represents started activity
     * @type {number}
     * @memberof ActivityWithRelationsResponse
     */
    'end_time_ms'?: number | null;
    /**
     * ID of the venue field
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'venue_field_id'?: string;
    /**
     * ID of the period depth type
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'period_depth_type_id'?: string;
    /**
     * ID of the associated sport
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'sport_id'?: string;
    /**
     * ID of the threshold set
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'threshold_set_id'?: string | null;
    /**
     * 
     * @type {Array<PeriodWithAthletes>}
     * @memberof ActivityWithRelationsResponse
     */
    'periods': Array<PeriodWithAthletes>;
    /**
     * User ID of the current owner of the activity
     * @type {string}
     * @memberof ActivityWithRelationsResponse
     */
    'owner_id'?: string;
}
/**
 * 
 * @export
 * @interface ActivityWithRelationsResponseAllOf
 */
export interface ActivityWithRelationsResponseAllOf {
    /**
     * 
     * @type {Array<PeriodWithAthletes>}
     * @memberof ActivityWithRelationsResponseAllOf
     */
    'periods': Array<PeriodWithAthletes>;
    /**
     * User ID of the current owner of the activity
     * @type {string}
     * @memberof ActivityWithRelationsResponseAllOf
     */
    'owner_id'?: string;
}
/**
 * 
 * @export
 * @interface AddPeriodTemplateTagTypeRequest
 */
export interface AddPeriodTemplateTagTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPeriodTemplateTagTypeRequest
     */
    'tag_type_id': string;
}
/**
 * 
 * @export
 * @interface Annotation
 */
export interface Annotation {
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'activity_id': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'annotation_layer_id': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'period_id': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'annotation_category_id': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof Annotation
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof Annotation
     */
    'end_time_ms': number;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'modified_at': string;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'comment'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Annotation
     */
    'athlete_ids': Array<string>;
    /**
     * The ID of the annotation in the source system, e.g. Focus. Used for deduplication.
     * @type {string}
     * @memberof Annotation
     */
    'imported_id'?: string;
}
/**
 * 
 * @export
 * @interface AnnotationCategory
 */
export interface AnnotationCategory {
    /**
     * 
     * @type {string}
     * @memberof AnnotationCategory
     */
    'id': string;
    /**
     * Display name
     * @type {string}
     * @memberof AnnotationCategory
     */
    'display_name': string;
    /**
     * Import name
     * @type {string}
     * @memberof AnnotationCategory
     */
    'import_name': string;
    /**
     * Pre-roll in whole seconds
     * @type {number}
     * @memberof AnnotationCategory
     */
    'start_offset': number;
    /**
     * Post-roll in whole seconds
     * @type {number}
     * @memberof AnnotationCategory
     */
    'end_offset': number;
    /**
     * HTML color in hexadecimal format. The color to use for annotations of this type.
     * @type {string}
     * @memberof AnnotationCategory
     */
    'default_color': string;
    /**
     * false or true. annotation category should be baked. If is_event = true then is_bakeable will be false.
     * @type {boolean}
     * @memberof AnnotationCategory
     */
    'is_bakeable': boolean;
    /**
     * false or true. An event might be a single event in time (like a Goal Keeper Save) vs a period of time (like ball in possession)
     * @type {boolean}
     * @memberof AnnotationCategory
     */
    'is_event': boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnotationCategory
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationCategory
     */
    'modified_at': string;
}
/**
 * 
 * @export
 * @interface AnnotationCategoryRequest
 */
export interface AnnotationCategoryRequest {
    /**
     * Display name
     * @type {string}
     * @memberof AnnotationCategoryRequest
     */
    'display_name': string;
    /**
     * Import name
     * @type {string}
     * @memberof AnnotationCategoryRequest
     */
    'import_name': string;
    /**
     * Pre-roll in whole seconds
     * @type {number}
     * @memberof AnnotationCategoryRequest
     */
    'start_offset': number;
    /**
     * Post-roll in whole seconds
     * @type {number}
     * @memberof AnnotationCategoryRequest
     */
    'end_offset': number;
    /**
     * HTML color in hexadecimal format. The color to use for annotations of this type.
     * @type {string}
     * @memberof AnnotationCategoryRequest
     */
    'default_color': string;
    /**
     * false or true annotation category should be baked. If is_event = true then is_bakeable will be false.
     * @type {boolean}
     * @memberof AnnotationCategoryRequest
     */
    'is_bakeable': boolean;
    /**
     * false or true. An event might be a single event in time (like a Goal Keeper Save) vs a period of time (like ball in possession)
     * @type {boolean}
     * @memberof AnnotationCategoryRequest
     */
    'is_event': boolean;
}
/**
 * 
 * @export
 * @interface AnnotationLayer
 */
export interface AnnotationLayer {
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayer
     */
    'activity_id': string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayer
     */
    'annotation_category_id': string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayer
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof AnnotationLayer
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof AnnotationLayer
     */
    'end_time_ms': number;
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayer
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayer
     */
    'modified_at': string;
}
/**
 * 
 * @export
 * @interface AnnotationLayerRequest
 */
export interface AnnotationLayerRequest {
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayerRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AnnotationLayerRequestWithAnnotations
 */
export interface AnnotationLayerRequestWithAnnotations {
    /**
     * 
     * @type {string}
     * @memberof AnnotationLayerRequestWithAnnotations
     */
    'name': string;
    /**
     * 
     * @type {Array<AnnotationRequest>}
     * @memberof AnnotationLayerRequestWithAnnotations
     */
    'annotations'?: Array<AnnotationRequest>;
}
/**
 * 
 * @export
 * @interface AnnotationLayerRequestWithAnnotationsAllOf
 */
export interface AnnotationLayerRequestWithAnnotationsAllOf {
    /**
     * 
     * @type {Array<AnnotationRequest>}
     * @memberof AnnotationLayerRequestWithAnnotationsAllOf
     */
    'annotations'?: Array<AnnotationRequest>;
}
/**
 * 
 * @export
 * @interface AnnotationRequest
 */
export interface AnnotationRequest {
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequest
     */
    'period_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequest
     */
    'annotation_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequest
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof AnnotationRequest
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof AnnotationRequest
     */
    'end_time_ms': number;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnnotationRequest
     */
    'athlete_ids'?: Array<string>;
    /**
     * The ID of the annotation in the source system, e.g. Focus. Used for deduplication.
     * @type {string}
     * @memberof AnnotationRequest
     */
    'imported_id'?: string;
}
/**
 * 
 * @export
 * @interface AnnotationRequestWithLayerId
 */
export interface AnnotationRequestWithLayerId {
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequestWithLayerId
     */
    'period_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequestWithLayerId
     */
    'annotation_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequestWithLayerId
     */
    'name': string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof AnnotationRequestWithLayerId
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof AnnotationRequestWithLayerId
     */
    'end_time_ms': number;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequestWithLayerId
     */
    'comment'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnnotationRequestWithLayerId
     */
    'athlete_ids'?: Array<string>;
    /**
     * The ID of the annotation in the source system, e.g. Focus. Used for deduplication.
     * @type {string}
     * @memberof AnnotationRequestWithLayerId
     */
    'imported_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequestWithLayerId
     */
    'annotation_layer_id': string;
}
/**
 * 
 * @export
 * @interface AnnotationRequestWithLayerIdAllOf
 */
export interface AnnotationRequestWithLayerIdAllOf {
    /**
     * 
     * @type {string}
     * @memberof AnnotationRequestWithLayerIdAllOf
     */
    'annotation_layer_id'?: string;
}
/**
 * 
 * @export
 * @interface AthleteError
 */
export interface AthleteError {
    /**
     * 
     * @type {AthleteErrorCode}
     * @memberof AthleteError
     */
    'error_code'?: AthleteErrorCode;
    /**
     * 
     * @type {Array<OverlappingPeriod>}
     * @memberof AthleteError
     */
    'overlapping_periods'?: Array<OverlappingPeriod>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AthleteErrorCode = {
    ConcurrentPeriods: 'concurrent_periods'
} as const;

export type AthleteErrorCode = typeof AthleteErrorCode[keyof typeof AthleteErrorCode];


/**
 * 
 * @export
 * @interface AthleteInPeriod
 */
export interface AthleteInPeriod {
    /**
     * 
     * @type {string}
     * @memberof AthleteInPeriod
     */
    'athlete_id': string;
    /**
     * 
     * @type {Array<Rotation>}
     * @memberof AthleteInPeriod
     */
    'rotations': Array<Rotation>;
}
/**
 * 
 * @export
 * @interface BaseErrorResponse
 */
export interface BaseErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof BaseErrorResponse
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface BatchDeleteRequest
 */
export interface BatchDeleteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchDeleteRequest
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface CopyActivityRequest
 */
export interface CopyActivityRequest {
    /**
     * Name of the new activity
     * @type {string}
     * @memberof CopyActivityRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreatePeriodTemplateRequest
 */
export interface CreatePeriodTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePeriodTemplateRequest
     */
    'value': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePeriodTemplateRequest
     */
    'tag_ids'?: Array<string>;
}
/**
 * Positional data source type
 * @export
 * @enum {string}
 */

export const DevicePositionalSource = {
    Gps: 'gps',
    Lps: 'lps'
} as const;

export type DevicePositionalSource = typeof DevicePositionalSource[keyof typeof DevicePositionalSource];


/**
 * 
 * @export
 * @interface EntityTagNameRequest
 */
export interface EntityTagNameRequest {
    /**
     * Name of the tag to apply or remove
     * @type {string}
     * @memberof EntityTagNameRequest
     */
    'tag_name': string;
    /**
     * Name of the tag type
     * @type {string}
     * @memberof EntityTagNameRequest
     */
    'tag_type_name': string;
}
/**
 * 
 * @export
 * @interface MoveAthleteActivityRequest
 */
export interface MoveAthleteActivityRequest {
    /**
     * List of athlete IDs to be moved
     * @type {Array<string>}
     * @memberof MoveAthleteActivityRequest
     */
    'athlete_ids'?: Array<string>;
    /**
     * ID of the target activity
     * @type {string}
     * @memberof MoveAthleteActivityRequest
     */
    'to_activity_id'?: string;
    /**
     * Whether to move periods
     * @type {boolean}
     * @memberof MoveAthleteActivityRequest
     */
    'move_periods'?: boolean;
    /**
     * Whether to move annotations
     * @type {boolean}
     * @memberof MoveAthleteActivityRequest
     */
    'move_annotations'?: boolean;
}
/**
 * 
 * @export
 * @interface MoveAthleteActivityResponse
 */
export interface MoveAthleteActivityResponse {
    /**
     * List of athlete ids that could not be moved
     * @type {Array<string>}
     * @memberof MoveAthleteActivityResponse
     */
    'athletes_not_moved'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OverlappingPeriod
 */
export interface OverlappingPeriod {
    /**
     * 
     * @type {string}
     * @memberof OverlappingPeriod
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OverlappingPeriod
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OverlappingPeriod
     */
    'activity_id': string;
    /**
     * 
     * @type {string}
     * @memberof OverlappingPeriod
     */
    'activity_name': string;
}
/**
 * 
 * @export
 * @interface Period
 */
export interface Period {
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    'activityId': string;
    /**
     * Name
     * @type {string}
     * @memberof Period
     */
    'name': string;
    /**
     * 
     * @type {DevicePositionalSource}
     * @memberof Period
     */
    'device_positional_source'?: DevicePositionalSource;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof Period
     */
    'start_time_ms': number;
    /**
     * Null represents started period
     * @type {number}
     * @memberof Period
     */
    'end_time_ms'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    'modified_at'?: string;
}
/**
 * 
 * @export
 * @interface PeriodAthleteRotation
 */
export interface PeriodAthleteRotation {
    /**
     * 
     * @type {string}
     * @memberof PeriodAthleteRotation
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeriodAthleteRotation
     */
    'period_athlete_id'?: string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof PeriodAthleteRotation
     */
    'start_time_ms': number;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof PeriodAthleteRotation
     */
    'end_time_ms'?: number;
}
/**
 * 
 * @export
 * @interface PeriodAthleteTagNameBatchItem
 */
export interface PeriodAthleteTagNameBatchItem {
    /**
     * ID of the athlete to tag within the period
     * @type {string}
     * @memberof PeriodAthleteTagNameBatchItem
     */
    'athlete_id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodAthleteTagNameBatchItem
     */
    'tag_name': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodAthleteTagNameBatchItem
     */
    'tag_type_name': string;
}
/**
 * 
 * @export
 * @interface PeriodError
 */
export interface PeriodError {
    /**
     * 
     * @type {PeriodErrorCode}
     * @memberof PeriodError
     */
    'error_code'?: PeriodErrorCode;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PeriodErrorCode = {
    NameRequired: 'name_required',
    NameInvalidCharacters: 'name_invalid_characters',
    NameTooLong: 'name_too_long',
    DurationTooLittle: 'duration_too_little',
    DurationTooMuch: 'duration_too_much',
    NoEndTimeSpecified: 'no_end_time_specified',
    NoStartTimeSpecified: 'no_start_time_specified',
    InvalidStartTime: 'invalid_start_time',
    InvalidEndTime: 'invalid_end_time',
    StartTimeEqualsEndTime: 'start_time_equals_end_time'
} as const;

export type PeriodErrorCode = typeof PeriodErrorCode[keyof typeof PeriodErrorCode];


/**
 * 
 * @export
 * @interface PeriodRequest
 */
export interface PeriodRequest {
    /**
     * Name
     * @type {string}
     * @memberof PeriodRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodRequest
     */
    'period_depth_id'?: string;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof PeriodRequest
     */
    'start_time_ms': number;
    /**
     * Null represents started period
     * @type {number}
     * @memberof PeriodRequest
     */
    'end_time_ms'?: number | null;
    /**
     * 
     * @type {DevicePositionalSource}
     * @memberof PeriodRequest
     */
    'device_positional_source'?: DevicePositionalSource;
}
/**
 * 
 * @export
 * @interface PeriodTagNameBatchItem
 */
export interface PeriodTagNameBatchItem {
    /**
     * ID of the period to tag
     * @type {string}
     * @memberof PeriodTagNameBatchItem
     */
    'period_id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTagNameBatchItem
     */
    'tag_name': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTagNameBatchItem
     */
    'tag_type_name': string;
}
/**
 * 
 * @export
 * @interface PeriodTemplate
 */
export interface PeriodTemplate {
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplate
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof PeriodTemplate
     */
    'is_visible': boolean;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplate
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplate
     */
    'modified_at': string;
    /**
     * 
     * @type {Array<PeriodTemplateTag>}
     * @memberof PeriodTemplate
     */
    'tags': Array<PeriodTemplateTag>;
}
/**
 * 
 * @export
 * @interface PeriodTemplateAllowedTagType
 */
export interface PeriodTemplateAllowedTagType {
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplateAllowedTagType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplateAllowedTagType
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PeriodTemplateTag
 */
export interface PeriodTemplateTag {
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplateTag
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplateTag
     */
    'tag_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplateTag
     */
    'tag_type_name': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodTemplateTag
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PeriodWithAthletes
 */
export interface PeriodWithAthletes {
    /**
     * 
     * @type {string}
     * @memberof PeriodWithAthletes
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PeriodWithAthletes
     */
    'activityId': string;
    /**
     * Name
     * @type {string}
     * @memberof PeriodWithAthletes
     */
    'name': string;
    /**
     * 
     * @type {DevicePositionalSource}
     * @memberof PeriodWithAthletes
     */
    'device_positional_source'?: DevicePositionalSource;
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof PeriodWithAthletes
     */
    'start_time_ms': number;
    /**
     * Null represents started period
     * @type {number}
     * @memberof PeriodWithAthletes
     */
    'end_time_ms': number | null;
    /**
     * 
     * @type {string}
     * @memberof PeriodWithAthletes
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeriodWithAthletes
     */
    'modified_at'?: string;
    /**
     * 
     * @type {Array<AthleteInPeriod>}
     * @memberof PeriodWithAthletes
     */
    'athletes': Array<AthleteInPeriod>;
}
/**
 * 
 * @export
 * @interface PeriodWithAthletesAllOf
 */
export interface PeriodWithAthletesAllOf {
    /**
     * 
     * @type {Array<AthleteInPeriod>}
     * @memberof PeriodWithAthletesAllOf
     */
    'athletes'?: Array<AthleteInPeriod>;
}
/**
 * 
 * @export
 * @interface Rotation
 */
export interface Rotation {
    /**
     * Epoch Timestamp, milliseconds since 1970-01-01T00:00:00Z
     * @type {number}
     * @memberof Rotation
     */
    'start_time_ms': number;
    /**
     * 
     * @type {number}
     * @memberof Rotation
     */
    'end_time_ms'?: number | null;
}
/**
 * 
 * @export
 * @interface TagResponse
 */
export interface TagResponse {
    /**
     * 
     * @type {string}
     * @memberof TagResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TagResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TagResponse
     */
    'tag_type_id': string;
    /**
     * 
     * @type {string}
     * @memberof TagResponse
     */
    'tag_type_name': string;
}
/**
 * Both fields are optional; only those present in the request are applied.
 * @export
 * @interface UpdatePeriodTemplateRequest
 */
export interface UpdatePeriodTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePeriodTemplateRequest
     */
    'value'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePeriodTemplateRequest
     */
    'tag_ids'?: Array<string>;
}

/**
 * ActivitiesApi - axios parameter creator
 * @export
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update an activity, its periods, athletes and rotations
         * @param {string} activityId ID of the activity
         * @param {ActivityUpdateBatchRequest} [activityUpdateBatchRequest] This API call updates everything about an activity in a single request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityUpdateBatch: async (activityId: string, activityUpdateBatchRequest?: ActivityUpdateBatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('activityUpdateBatch', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}/batch`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityUpdateBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new activity
         * @param {ActivityRequest} activityRequest Create a new activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity: async (activityRequest: ActivityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityRequest' is not null or undefined
            assertParamExists('createActivity', 'activityRequest', activityRequest)
            const localVarPath = `/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Activity From Existing Activity
         * @param {string} activityId ID of the activity
         * @param {CopyActivityRequest} copyActivityRequest Create a new activity from an existing activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityCopy: async (activityId: string, copyActivityRequest: CopyActivityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('createActivityCopy', 'activityId', activityId)
            // verify required parameter 'copyActivityRequest' is not null or undefined
            assertParamExists('createActivityCopy', 'copyActivityRequest', copyActivityRequest)
            const localVarPath = `/activities/{activityId}/copy`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a tag from an athlete in an activity
         * @param {string} activityId ID of the activity
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityAthleteTags: async (activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('deleteActivityAthleteTags', 'activityId', activityId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('deleteActivityAthleteTags', 'athleteId', athleteId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('deleteActivityAthleteTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/activities/{activityId}/athletes/{athleteId}/tags`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"athleteId"}}`, encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a tag from an activity
         * @param {string} activityId ID of the activity
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityTags: async (activityId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('deleteActivityTags', 'activityId', activityId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('deleteActivityTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/activities/{activityId}/tags`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivities: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get activity with relations
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivity', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all overlapping activities
         * @param {number} startTime The start of the time range (exclusive) in seconds since epoch
         * @param {number} endTime The end of the time range (exclusive) in seconds since epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverlappingActivities: async (startTime: number, endTime: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getOverlappingActivities', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getOverlappingActivities', 'endTime', endTime)
            const localVarPath = `/activities/overlapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move athletes to another activity
         * @param {string} activityId ID of the activity
         * @param {MoveAthleteActivityRequest} moveAthleteActivityRequest Move athletes to another activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAthletesToAnotherActivity: async (activityId: string, moveAthleteActivityRequest: MoveAthleteActivityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('moveAthletesToAnotherActivity', 'activityId', activityId)
            // verify required parameter 'moveAthleteActivityRequest' is not null or undefined
            assertParamExists('moveAthletesToAnotherActivity', 'moveAthleteActivityRequest', moveAthleteActivityRequest)
            const localVarPath = `/activities/{activityId}/move-athletes`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveAthleteActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to an athlete in an activity
         * @param {string} activityId ID of the activity
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityAthleteTags: async (activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('patchActivityAthleteTags', 'activityId', activityId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('patchActivityAthleteTags', 'athleteId', athleteId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('patchActivityAthleteTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/activities/{activityId}/athletes/{athleteId}/tags`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"athleteId"}}`, encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to multiple athletes in an activity
         * @param {string} activityId ID of the activity
         * @param {Array<ActivityAthleteTagNameBatchItem>} activityAthleteTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityAthleteTagsBatch: async (activityId: string, activityAthleteTagNameBatchItem: Array<ActivityAthleteTagNameBatchItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('patchActivityAthleteTagsBatch', 'activityId', activityId)
            // verify required parameter 'activityAthleteTagNameBatchItem' is not null or undefined
            assertParamExists('patchActivityAthleteTagsBatch', 'activityAthleteTagNameBatchItem', activityAthleteTagNameBatchItem)
            const localVarPath = `/activities/{activityId}/athletes/tags`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityAthleteTagNameBatchItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to an activity
         * @param {string} activityId ID of the activity
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityTags: async (activityId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('patchActivityTags', 'activityId', activityId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('patchActivityTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/activities/{activityId}/tags`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to multiple activities
         * @param {Array<ActivityTagNameBatchItem>} activityTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityTagsBatch: async (activityTagNameBatchItem: Array<ActivityTagNameBatchItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityTagNameBatchItem' is not null or undefined
            assertParamExists('patchActivityTagsBatch', 'activityTagNameBatchItem', activityTagNameBatchItem)
            const localVarPath = `/activities/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityTagNameBatchItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an activity
         * @param {string} activityId ID of the activity
         * @param {ActivityRequest} activityRequest Update Activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity: async (activityId: string, activityRequest: ActivityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('updateActivity', 'activityId', activityId)
            // verify required parameter 'activityRequest' is not null or undefined
            assertParamExists('updateActivity', 'activityRequest', activityRequest)
            const localVarPath = `/activities/{activityId}`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesApi - functional programming interface
 * @export
 */
export const ActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update an activity, its periods, athletes and rotations
         * @param {string} activityId ID of the activity
         * @param {ActivityUpdateBatchRequest} [activityUpdateBatchRequest] This API call updates everything about an activity in a single request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activityUpdateBatch(activityId: string, activityUpdateBatchRequest?: ActivityUpdateBatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activityUpdateBatch(activityId, activityUpdateBatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new activity
         * @param {ActivityRequest} activityRequest Create a new activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivity(activityRequest: ActivityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivity(activityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Activity From Existing Activity
         * @param {string} activityId ID of the activity
         * @param {CopyActivityRequest} copyActivityRequest Create a new activity from an existing activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivityCopy(activityId: string, copyActivityRequest: CopyActivityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivityCopy(activityId, copyActivityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a tag from an athlete in an activity
         * @param {string} activityId ID of the activity
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivityAthleteTags(activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivityAthleteTags(activityId, athleteId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a tag from an activity
         * @param {string} activityId ID of the activity
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivityTags(activityId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivityTags(activityId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivities(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivities(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get activity with relations
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityWithRelationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all overlapping activities
         * @param {number} startTime The start of the time range (exclusive) in seconds since epoch
         * @param {number} endTime The end of the time range (exclusive) in seconds since epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverlappingActivities(startTime: number, endTime: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverlappingActivities(startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move athletes to another activity
         * @param {string} activityId ID of the activity
         * @param {MoveAthleteActivityRequest} moveAthleteActivityRequest Move athletes to another activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveAthletesToAnotherActivity(activityId: string, moveAthleteActivityRequest: MoveAthleteActivityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoveAthleteActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveAthletesToAnotherActivity(activityId, moveAthleteActivityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to an athlete in an activity
         * @param {string} activityId ID of the activity
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivityAthleteTags(activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivityAthleteTags(activityId, athleteId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to multiple athletes in an activity
         * @param {string} activityId ID of the activity
         * @param {Array<ActivityAthleteTagNameBatchItem>} activityAthleteTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivityAthleteTagsBatch(activityId: string, activityAthleteTagNameBatchItem: Array<ActivityAthleteTagNameBatchItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivityAthleteTagsBatch(activityId, activityAthleteTagNameBatchItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to an activity
         * @param {string} activityId ID of the activity
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivityTags(activityId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivityTags(activityId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to multiple activities
         * @param {Array<ActivityTagNameBatchItem>} activityTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivityTagsBatch(activityTagNameBatchItem: Array<ActivityTagNameBatchItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivityTagsBatch(activityTagNameBatchItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an activity
         * @param {string} activityId ID of the activity
         * @param {ActivityRequest} activityRequest Update Activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActivity(activityId: string, activityRequest: ActivityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActivity(activityId, activityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActivitiesApi - factory interface
 * @export
 */
export const ActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Update an activity, its periods, athletes and rotations
         * @param {string} activityId ID of the activity
         * @param {ActivityUpdateBatchRequest} [activityUpdateBatchRequest] This API call updates everything about an activity in a single request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityUpdateBatch(activityId: string, activityUpdateBatchRequest?: ActivityUpdateBatchRequest, options?: any): AxiosPromise<ActivityBatchResponse> {
            return localVarFp.activityUpdateBatch(activityId, activityUpdateBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new activity
         * @param {ActivityRequest} activityRequest Create a new activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity(activityRequest: ActivityRequest, options?: any): AxiosPromise<ActivityResponse> {
            return localVarFp.createActivity(activityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Activity From Existing Activity
         * @param {string} activityId ID of the activity
         * @param {CopyActivityRequest} copyActivityRequest Create a new activity from an existing activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityCopy(activityId: string, copyActivityRequest: CopyActivityRequest, options?: any): AxiosPromise<ActivityResponse> {
            return localVarFp.createActivityCopy(activityId, copyActivityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a tag from an athlete in an activity
         * @param {string} activityId ID of the activity
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityAthleteTags(activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteActivityAthleteTags(activityId, athleteId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a tag from an activity
         * @param {string} activityId ID of the activity
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityTags(activityId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteActivityTags(activityId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivities(options?: any): AxiosPromise<ActivitiesResponse> {
            return localVarFp.getActivities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get activity with relations
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(activityId: string, options?: any): AxiosPromise<ActivityWithRelationsResponse> {
            return localVarFp.getActivity(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all overlapping activities
         * @param {number} startTime The start of the time range (exclusive) in seconds since epoch
         * @param {number} endTime The end of the time range (exclusive) in seconds since epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverlappingActivities(startTime: number, endTime: number, options?: any): AxiosPromise<Array<ActivityResponse>> {
            return localVarFp.getOverlappingActivities(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move athletes to another activity
         * @param {string} activityId ID of the activity
         * @param {MoveAthleteActivityRequest} moveAthleteActivityRequest Move athletes to another activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAthletesToAnotherActivity(activityId: string, moveAthleteActivityRequest: MoveAthleteActivityRequest, options?: any): AxiosPromise<MoveAthleteActivityResponse> {
            return localVarFp.moveAthletesToAnotherActivity(activityId, moveAthleteActivityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to an athlete in an activity
         * @param {string} activityId ID of the activity
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityAthleteTags(activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.patchActivityAthleteTags(activityId, athleteId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to multiple athletes in an activity
         * @param {string} activityId ID of the activity
         * @param {Array<ActivityAthleteTagNameBatchItem>} activityAthleteTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityAthleteTagsBatch(activityId: string, activityAthleteTagNameBatchItem: Array<ActivityAthleteTagNameBatchItem>, options?: any): AxiosPromise<void> {
            return localVarFp.patchActivityAthleteTagsBatch(activityId, activityAthleteTagNameBatchItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to an activity
         * @param {string} activityId ID of the activity
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityTags(activityId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.patchActivityTags(activityId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to multiple activities
         * @param {Array<ActivityTagNameBatchItem>} activityTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityTagsBatch(activityTagNameBatchItem: Array<ActivityTagNameBatchItem>, options?: any): AxiosPromise<void> {
            return localVarFp.patchActivityTagsBatch(activityTagNameBatchItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an activity
         * @param {string} activityId ID of the activity
         * @param {ActivityRequest} activityRequest Update Activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(activityId: string, activityRequest: ActivityRequest, options?: any): AxiosPromise<ActivityResponse> {
            return localVarFp.updateActivity(activityId, activityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesApi - object-oriented interface
 * @export
 * @class ActivitiesApi
 * @extends {BaseAPI}
 */
export class ActivitiesApi extends BaseAPI {
    /**
     * 
     * @summary Update an activity, its periods, athletes and rotations
     * @param {string} activityId ID of the activity
     * @param {ActivityUpdateBatchRequest} [activityUpdateBatchRequest] This API call updates everything about an activity in a single request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activityUpdateBatch(activityId: string, activityUpdateBatchRequest?: ActivityUpdateBatchRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activityUpdateBatch(activityId, activityUpdateBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new activity
     * @param {ActivityRequest} activityRequest Create a new activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public createActivity(activityRequest: ActivityRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).createActivity(activityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Activity From Existing Activity
     * @param {string} activityId ID of the activity
     * @param {CopyActivityRequest} copyActivityRequest Create a new activity from an existing activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public createActivityCopy(activityId: string, copyActivityRequest: CopyActivityRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).createActivityCopy(activityId, copyActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a tag from an athlete in an activity
     * @param {string} activityId ID of the activity
     * @param {string} athleteId ID of the athlete
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public deleteActivityAthleteTags(activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).deleteActivityAthleteTags(activityId, athleteId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a tag from an activity
     * @param {string} activityId ID of the activity
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public deleteActivityTags(activityId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).deleteActivityTags(activityId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivities(options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get activity with relations
     * @param {string} activityId ID of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivity(activityId: string, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all overlapping activities
     * @param {number} startTime The start of the time range (exclusive) in seconds since epoch
     * @param {number} endTime The end of the time range (exclusive) in seconds since epoch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getOverlappingActivities(startTime: number, endTime: number, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getOverlappingActivities(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move athletes to another activity
     * @param {string} activityId ID of the activity
     * @param {MoveAthleteActivityRequest} moveAthleteActivityRequest Move athletes to another activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public moveAthletesToAnotherActivity(activityId: string, moveAthleteActivityRequest: MoveAthleteActivityRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).moveAthletesToAnotherActivity(activityId, moveAthleteActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to an athlete in an activity
     * @param {string} activityId ID of the activity
     * @param {string} athleteId ID of the athlete
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public patchActivityAthleteTags(activityId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).patchActivityAthleteTags(activityId, athleteId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to multiple athletes in an activity
     * @param {string} activityId ID of the activity
     * @param {Array<ActivityAthleteTagNameBatchItem>} activityAthleteTagNameBatchItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public patchActivityAthleteTagsBatch(activityId: string, activityAthleteTagNameBatchItem: Array<ActivityAthleteTagNameBatchItem>, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).patchActivityAthleteTagsBatch(activityId, activityAthleteTagNameBatchItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to an activity
     * @param {string} activityId ID of the activity
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public patchActivityTags(activityId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).patchActivityTags(activityId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to multiple activities
     * @param {Array<ActivityTagNameBatchItem>} activityTagNameBatchItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public patchActivityTagsBatch(activityTagNameBatchItem: Array<ActivityTagNameBatchItem>, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).patchActivityTagsBatch(activityTagNameBatchItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an activity
     * @param {string} activityId ID of the activity
     * @param {ActivityRequest} activityRequest Update Activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public updateActivity(activityId: string, activityRequest: ActivityRequest, options?: AxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).updateActivity(activityId, activityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ActivityTeamsApi - axios parameter creator
 * @export
 */
export const ActivityTeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new team to an existing activity
         * @summary Add a team to an activity
         * @param {string} activityId ID of the activity
         * @param {string} body New activity team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityTeam: async (activityId: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('createActivityTeam', 'activityId', activityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createActivityTeam', 'body', body)
            const localVarPath = `/activities/{activityId}/teams`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a team from an activity
         * @param {string} activityId ID of the activity
         * @param {string} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityTeam: async (activityId: string, teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('deleteActivityTeam', 'activityId', activityId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteActivityTeam', 'teamId', teamId)
            const localVarPath = `/activities/{activityId}/teams/{teamId}`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityTeams: async (activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivityTeams', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}/teams`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityTeamsApi - functional programming interface
 * @export
 */
export const ActivityTeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityTeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new team to an existing activity
         * @summary Add a team to an activity
         * @param {string} activityId ID of the activity
         * @param {string} body New activity team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivityTeam(activityId: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivityTeam(activityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a team from an activity
         * @param {string} activityId ID of the activity
         * @param {string} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivityTeam(activityId: string, teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivityTeam(activityId, teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityTeams(activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityTeams(activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActivityTeamsApi - factory interface
 * @export
 */
export const ActivityTeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityTeamsApiFp(configuration)
    return {
        /**
         * Add a new team to an existing activity
         * @summary Add a team to an activity
         * @param {string} activityId ID of the activity
         * @param {string} body New activity team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityTeam(activityId: string, body: string, options?: any): AxiosPromise<string> {
            return localVarFp.createActivityTeam(activityId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a team from an activity
         * @param {string} activityId ID of the activity
         * @param {string} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityTeam(activityId: string, teamId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteActivityTeam(activityId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityTeams(activityId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getActivityTeams(activityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityTeamsApi - object-oriented interface
 * @export
 * @class ActivityTeamsApi
 * @extends {BaseAPI}
 */
export class ActivityTeamsApi extends BaseAPI {
    /**
     * Add a new team to an existing activity
     * @summary Add a team to an activity
     * @param {string} activityId ID of the activity
     * @param {string} body New activity team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTeamsApi
     */
    public createActivityTeam(activityId: string, body: string, options?: AxiosRequestConfig) {
        return ActivityTeamsApiFp(this.configuration).createActivityTeam(activityId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a team from an activity
     * @param {string} activityId ID of the activity
     * @param {string} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTeamsApi
     */
    public deleteActivityTeam(activityId: string, teamId: string, options?: AxiosRequestConfig) {
        return ActivityTeamsApiFp(this.configuration).deleteActivityTeam(activityId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams for an activity
     * @param {string} activityId ID of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTeamsApi
     */
    public getActivityTeams(activityId: string, options?: AxiosRequestConfig) {
        return ActivityTeamsApiFp(this.configuration).getActivityTeams(activityId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnnotationCategoriesApi - axios parameter creator
 * @export
 */
export const AnnotationCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create multiple annotation categories in a single request
         * @summary Create annotation categories
         * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationCategories: async (annotationCategoryRequest: Array<AnnotationCategoryRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationCategoryRequest' is not null or undefined
            assertParamExists('createAnnotationCategories', 'annotationCategoryRequest', annotationCategoryRequest)
            const localVarPath = `/annotation_categories/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new annotation category
         * @param {AnnotationCategoryRequest} annotationCategoryRequest New annotation category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationCategory: async (annotationCategoryRequest: AnnotationCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationCategoryRequest' is not null or undefined
            assertParamExists('createAnnotationCategory', 'annotationCategoryRequest', annotationCategoryRequest)
            const localVarPath = `/annotation_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all annotation categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/annotation_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an annotation category
         * @param {string} annotationCategoryId ID of the annotation category
         * @param {AnnotationCategoryRequest} annotationCategoryRequest Updated annotation category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotationCategory: async (annotationCategoryId: string, annotationCategoryRequest: AnnotationCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationCategoryId' is not null or undefined
            assertParamExists('updateAnnotationCategory', 'annotationCategoryId', annotationCategoryId)
            // verify required parameter 'annotationCategoryRequest' is not null or undefined
            assertParamExists('updateAnnotationCategory', 'annotationCategoryRequest', annotationCategoryRequest)
            const localVarPath = `/annotation_categories/{annotationCategoryId}`
                .replace(`{${"annotationCategoryId"}}`, encodeURIComponent(String(annotationCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnotationCategoriesApi - functional programming interface
 * @export
 */
export const AnnotationCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnotationCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create multiple annotation categories in a single request
         * @summary Create annotation categories
         * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotationCategories(annotationCategoryRequest: Array<AnnotationCategoryRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotationCategories(annotationCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new annotation category
         * @param {AnnotationCategoryRequest} annotationCategoryRequest New annotation category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotationCategory(annotationCategoryRequest: AnnotationCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotationCategory(annotationCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all annotation categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an annotation category
         * @param {string} annotationCategoryId ID of the annotation category
         * @param {AnnotationCategoryRequest} annotationCategoryRequest Updated annotation category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnotationCategory(annotationCategoryId: string, annotationCategoryRequest: AnnotationCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnotationCategory(annotationCategoryId, annotationCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnnotationCategoriesApi - factory interface
 * @export
 */
export const AnnotationCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnotationCategoriesApiFp(configuration)
    return {
        /**
         * Create multiple annotation categories in a single request
         * @summary Create annotation categories
         * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationCategories(annotationCategoryRequest: Array<AnnotationCategoryRequest>, options?: any): AxiosPromise<Array<AnnotationCategory>> {
            return localVarFp.createAnnotationCategories(annotationCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new annotation category
         * @param {AnnotationCategoryRequest} annotationCategoryRequest New annotation category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationCategory(annotationCategoryRequest: AnnotationCategoryRequest, options?: any): AxiosPromise<AnnotationCategory> {
            return localVarFp.createAnnotationCategory(annotationCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all annotation categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationCategories(options?: any): AxiosPromise<Array<AnnotationCategory>> {
            return localVarFp.getAnnotationCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an annotation category
         * @param {string} annotationCategoryId ID of the annotation category
         * @param {AnnotationCategoryRequest} annotationCategoryRequest Updated annotation category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotationCategory(annotationCategoryId: string, annotationCategoryRequest: AnnotationCategoryRequest, options?: any): AxiosPromise<AnnotationCategory> {
            return localVarFp.updateAnnotationCategory(annotationCategoryId, annotationCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnotationCategoriesApi - object-oriented interface
 * @export
 * @class AnnotationCategoriesApi
 * @extends {BaseAPI}
 */
export class AnnotationCategoriesApi extends BaseAPI {
    /**
     * Create multiple annotation categories in a single request
     * @summary Create annotation categories
     * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationCategoriesApi
     */
    public createAnnotationCategories(annotationCategoryRequest: Array<AnnotationCategoryRequest>, options?: AxiosRequestConfig) {
        return AnnotationCategoriesApiFp(this.configuration).createAnnotationCategories(annotationCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new annotation category
     * @param {AnnotationCategoryRequest} annotationCategoryRequest New annotation category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationCategoriesApi
     */
    public createAnnotationCategory(annotationCategoryRequest: AnnotationCategoryRequest, options?: AxiosRequestConfig) {
        return AnnotationCategoriesApiFp(this.configuration).createAnnotationCategory(annotationCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all annotation categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationCategoriesApi
     */
    public getAnnotationCategories(options?: AxiosRequestConfig) {
        return AnnotationCategoriesApiFp(this.configuration).getAnnotationCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an annotation category
     * @param {string} annotationCategoryId ID of the annotation category
     * @param {AnnotationCategoryRequest} annotationCategoryRequest Updated annotation category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationCategoriesApi
     */
    public updateAnnotationCategory(annotationCategoryId: string, annotationCategoryRequest: AnnotationCategoryRequest, options?: AxiosRequestConfig) {
        return AnnotationCategoriesApiFp(this.configuration).updateAnnotationCategory(annotationCategoryId, annotationCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnnotationLayersApi - axios parameter creator
 * @export
 */
export const AnnotationLayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new annotation layer and annotations for an activity in a single request
         * @summary Create a new annotation layer and annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationLayerForActivity: async (activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('createAnnotationLayerForActivity', 'activityId', activityId)
            // verify required parameter 'annotationLayerRequestWithAnnotations' is not null or undefined
            assertParamExists('createAnnotationLayerForActivity', 'annotationLayerRequestWithAnnotations', annotationLayerRequestWithAnnotations)
            const localVarPath = `/activities/{activityId}/annotation_layers`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationLayerRequestWithAnnotations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotationLayer: async (annotationLayerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationLayerId' is not null or undefined
            assertParamExists('deleteAnnotationLayer', 'annotationLayerId', annotationLayerId)
            const localVarPath = `/annotation_layers/{annotationLayerId}`
                .replace(`{${"annotationLayerId"}}`, encodeURIComponent(String(annotationLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annotation layer
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayer: async (annotationLayerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationLayerId' is not null or undefined
            assertParamExists('getAnnotationLayer', 'annotationLayerId', annotationLayerId)
            const localVarPath = `/annotation_layers/{annotationLayerId}`
                .replace(`{${"annotationLayerId"}}`, encodeURIComponent(String(annotationLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayersForActivity: async (activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getAnnotationLayersForActivity', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}/annotation_layers`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnotationLayersApi - functional programming interface
 * @export
 */
export const AnnotationLayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnotationLayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new annotation layer and annotations for an activity in a single request
         * @summary Create a new annotation layer and annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotationLayerForActivity(activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationLayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotationLayerForActivity(activityId, annotationLayerRequestWithAnnotations, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnotationLayer(annotationLayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annotation layer
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationLayer(annotationLayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationLayersForActivity(activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationLayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationLayersForActivity(activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnnotationLayersApi - factory interface
 * @export
 */
export const AnnotationLayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnotationLayersApiFp(configuration)
    return {
        /**
         * Create a new annotation layer and annotations for an activity in a single request
         * @summary Create a new annotation layer and annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationLayerForActivity(activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options?: any): AxiosPromise<AnnotationLayer> {
            return localVarFp.createAnnotationLayerForActivity(activityId, annotationLayerRequestWithAnnotations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotationLayer(annotationLayerId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAnnotationLayer(annotationLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annotation layer
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayer(annotationLayerId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getAnnotationLayer(annotationLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayersForActivity(activityId: string, options?: any): AxiosPromise<Array<AnnotationLayer>> {
            return localVarFp.getAnnotationLayersForActivity(activityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnotationLayersApi - object-oriented interface
 * @export
 * @class AnnotationLayersApi
 * @extends {BaseAPI}
 */
export class AnnotationLayersApi extends BaseAPI {
    /**
     * Create a new annotation layer and annotations for an activity in a single request
     * @summary Create a new annotation layer and annotations for an activity
     * @param {string} activityId ID of the activity
     * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationLayersApi
     */
    public createAnnotationLayerForActivity(activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options?: AxiosRequestConfig) {
        return AnnotationLayersApiFp(this.configuration).createAnnotationLayerForActivity(activityId, annotationLayerRequestWithAnnotations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an annotation layer and all its annotations
     * @param {string} annotationLayerId ID of the annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationLayersApi
     */
    public deleteAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig) {
        return AnnotationLayersApiFp(this.configuration).deleteAnnotationLayer(annotationLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annotation layer
     * @param {string} annotationLayerId ID of the annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationLayersApi
     */
    public getAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig) {
        return AnnotationLayersApiFp(this.configuration).getAnnotationLayer(annotationLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annotation layers for an activity
     * @param {string} activityId ID of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationLayersApi
     */
    public getAnnotationLayersForActivity(activityId: string, options?: AxiosRequestConfig) {
        return AnnotationLayersApiFp(this.configuration).getAnnotationLayersForActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnnotationsApi - axios parameter creator
 * @export
 */
export const AnnotationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new annotation
         * @param {string} activityId ID of the activity
         * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotation: async (activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('createAnnotation', 'activityId', activityId)
            // verify required parameter 'annotationRequestWithLayerId' is not null or undefined
            assertParamExists('createAnnotation', 'annotationRequestWithLayerId', annotationRequestWithLayerId)
            const localVarPath = `/activities/{activityId}/annotations`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationRequestWithLayerId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple annotations in a single request
         * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotations: async (batchDeleteRequest: BatchDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchDeleteRequest' is not null or undefined
            assertParamExists('deleteAnnotations', 'batchDeleteRequest', batchDeleteRequest)
            const localVarPath = `/annotations/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationsForActivity: async (activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getAnnotationsForActivity', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}/annotations`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an annotation
         * @param {string} annotationId ID of the annotation
         * @param {AnnotationRequest} annotationRequest Updated annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotation: async (annotationId: string, annotationRequest: AnnotationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationId' is not null or undefined
            assertParamExists('updateAnnotation', 'annotationId', annotationId)
            // verify required parameter 'annotationRequest' is not null or undefined
            assertParamExists('updateAnnotation', 'annotationRequest', annotationRequest)
            const localVarPath = `/annotations/{annotationId}`
                .replace(`{${"annotationId"}}`, encodeURIComponent(String(annotationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the athletes associated with an annotation
         * @param {string} annotationId ID of the annotation
         * @param {Array<string>} requestBody Updated athletes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotationAthletes: async (annotationId: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationId' is not null or undefined
            assertParamExists('updateAnnotationAthletes', 'annotationId', annotationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateAnnotationAthletes', 'requestBody', requestBody)
            const localVarPath = `/annotations/{annotationId}/athletes`
                .replace(`{${"annotationId"}}`, encodeURIComponent(String(annotationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnotationsApi - functional programming interface
 * @export
 */
export const AnnotationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnotationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new annotation
         * @param {string} activityId ID of the activity
         * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotation(activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Annotation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotation(activityId, annotationRequestWithLayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete multiple annotations in a single request
         * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnotations(batchDeleteRequest: BatchDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnotations(batchDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationsForActivity(activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Annotation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationsForActivity(activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an annotation
         * @param {string} annotationId ID of the annotation
         * @param {AnnotationRequest} annotationRequest Updated annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnotation(annotationId: string, annotationRequest: AnnotationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Annotation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnotation(annotationId, annotationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the athletes associated with an annotation
         * @param {string} annotationId ID of the annotation
         * @param {Array<string>} requestBody Updated athletes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnotationAthletes(annotationId: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnotationAthletes(annotationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnnotationsApi - factory interface
 * @export
 */
export const AnnotationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnotationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new annotation
         * @param {string} activityId ID of the activity
         * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotation(activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options?: any): AxiosPromise<Annotation> {
            return localVarFp.createAnnotation(activityId, annotationRequestWithLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple annotations in a single request
         * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotations(batchDeleteRequest: BatchDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAnnotations(batchDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationsForActivity(activityId: string, options?: any): AxiosPromise<Array<Annotation>> {
            return localVarFp.getAnnotationsForActivity(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an annotation
         * @param {string} annotationId ID of the annotation
         * @param {AnnotationRequest} annotationRequest Updated annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotation(annotationId: string, annotationRequest: AnnotationRequest, options?: any): AxiosPromise<Annotation> {
            return localVarFp.updateAnnotation(annotationId, annotationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the athletes associated with an annotation
         * @param {string} annotationId ID of the annotation
         * @param {Array<string>} requestBody Updated athletes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotationAthletes(annotationId: string, requestBody: Array<string>, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.updateAnnotationAthletes(annotationId, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnotationsApi - object-oriented interface
 * @export
 * @class AnnotationsApi
 * @extends {BaseAPI}
 */
export class AnnotationsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new annotation
     * @param {string} activityId ID of the activity
     * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationsApi
     */
    public createAnnotation(activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options?: AxiosRequestConfig) {
        return AnnotationsApiFp(this.configuration).createAnnotation(activityId, annotationRequestWithLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple annotations in a single request
     * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationsApi
     */
    public deleteAnnotations(batchDeleteRequest: BatchDeleteRequest, options?: AxiosRequestConfig) {
        return AnnotationsApiFp(this.configuration).deleteAnnotations(batchDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annotations for an activity
     * @param {string} activityId ID of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationsApi
     */
    public getAnnotationsForActivity(activityId: string, options?: AxiosRequestConfig) {
        return AnnotationsApiFp(this.configuration).getAnnotationsForActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an annotation
     * @param {string} annotationId ID of the annotation
     * @param {AnnotationRequest} annotationRequest Updated annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationsApi
     */
    public updateAnnotation(annotationId: string, annotationRequest: AnnotationRequest, options?: AxiosRequestConfig) {
        return AnnotationsApiFp(this.configuration).updateAnnotation(annotationId, annotationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the athletes associated with an annotation
     * @param {string} annotationId ID of the annotation
     * @param {Array<string>} requestBody Updated athletes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationsApi
     */
    public updateAnnotationAthletes(annotationId: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return AnnotationsApiFp(this.configuration).updateAnnotationAthletes(annotationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImportersApi - axios parameter creator
 * @export
 */
export const ImportersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create multiple annotation categories in a single request
         * @summary Create annotation categories
         * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationCategories: async (annotationCategoryRequest: Array<AnnotationCategoryRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationCategoryRequest' is not null or undefined
            assertParamExists('createAnnotationCategories', 'annotationCategoryRequest', annotationCategoryRequest)
            const localVarPath = `/annotation_categories/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new annotation layer and annotations for an activity in a single request
         * @summary Create a new annotation layer and annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationLayerForActivity: async (activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('createAnnotationLayerForActivity', 'activityId', activityId)
            // verify required parameter 'annotationLayerRequestWithAnnotations' is not null or undefined
            assertParamExists('createAnnotationLayerForActivity', 'annotationLayerRequestWithAnnotations', annotationLayerRequestWithAnnotations)
            const localVarPath = `/activities/{activityId}/annotation_layers`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationLayerRequestWithAnnotations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotationLayer: async (annotationLayerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationLayerId' is not null or undefined
            assertParamExists('deleteAnnotationLayer', 'annotationLayerId', annotationLayerId)
            const localVarPath = `/annotation_layers/{annotationLayerId}`
                .replace(`{${"annotationLayerId"}}`, encodeURIComponent(String(annotationLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all annotation categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/annotation_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayersForActivity: async (activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getAnnotationLayersForActivity', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}/annotation_layers`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportersApi - functional programming interface
 * @export
 */
export const ImportersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create multiple annotation categories in a single request
         * @summary Create annotation categories
         * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotationCategories(annotationCategoryRequest: Array<AnnotationCategoryRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotationCategories(annotationCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new annotation layer and annotations for an activity in a single request
         * @summary Create a new annotation layer and annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotationLayerForActivity(activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationLayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotationLayerForActivity(activityId, annotationLayerRequestWithAnnotations, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnotationLayer(annotationLayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all annotation categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationLayersForActivity(activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationLayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationLayersForActivity(activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImportersApi - factory interface
 * @export
 */
export const ImportersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportersApiFp(configuration)
    return {
        /**
         * Create multiple annotation categories in a single request
         * @summary Create annotation categories
         * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationCategories(annotationCategoryRequest: Array<AnnotationCategoryRequest>, options?: any): AxiosPromise<Array<AnnotationCategory>> {
            return localVarFp.createAnnotationCategories(annotationCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new annotation layer and annotations for an activity in a single request
         * @summary Create a new annotation layer and annotations for an activity
         * @param {string} activityId ID of the activity
         * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotationLayerForActivity(activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options?: any): AxiosPromise<AnnotationLayer> {
            return localVarFp.createAnnotationLayerForActivity(activityId, annotationLayerRequestWithAnnotations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotationLayer(annotationLayerId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAnnotationLayer(annotationLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all annotation categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationCategories(options?: any): AxiosPromise<Array<AnnotationCategory>> {
            return localVarFp.getAnnotationCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayersForActivity(activityId: string, options?: any): AxiosPromise<Array<AnnotationLayer>> {
            return localVarFp.getAnnotationLayersForActivity(activityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportersApi - object-oriented interface
 * @export
 * @class ImportersApi
 * @extends {BaseAPI}
 */
export class ImportersApi extends BaseAPI {
    /**
     * Create multiple annotation categories in a single request
     * @summary Create annotation categories
     * @param {Array<AnnotationCategoryRequest>} annotationCategoryRequest Annotation categories to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportersApi
     */
    public createAnnotationCategories(annotationCategoryRequest: Array<AnnotationCategoryRequest>, options?: AxiosRequestConfig) {
        return ImportersApiFp(this.configuration).createAnnotationCategories(annotationCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new annotation layer and annotations for an activity in a single request
     * @summary Create a new annotation layer and annotations for an activity
     * @param {string} activityId ID of the activity
     * @param {AnnotationLayerRequestWithAnnotations} annotationLayerRequestWithAnnotations New annotation layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportersApi
     */
    public createAnnotationLayerForActivity(activityId: string, annotationLayerRequestWithAnnotations: AnnotationLayerRequestWithAnnotations, options?: AxiosRequestConfig) {
        return ImportersApiFp(this.configuration).createAnnotationLayerForActivity(activityId, annotationLayerRequestWithAnnotations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an annotation layer and all its annotations
     * @param {string} annotationLayerId ID of the annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportersApi
     */
    public deleteAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig) {
        return ImportersApiFp(this.configuration).deleteAnnotationLayer(annotationLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all annotation categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportersApi
     */
    public getAnnotationCategories(options?: AxiosRequestConfig) {
        return ImportersApiFp(this.configuration).getAnnotationCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annotation layers for an activity
     * @param {string} activityId ID of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportersApi
     */
    public getAnnotationLayersForActivity(activityId: string, options?: AxiosRequestConfig) {
        return ImportersApiFp(this.configuration).getAnnotationLayersForActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PeriodTemplatesApi - axios parameter creator
 * @export
 */
export const PeriodTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Permit an additional tag_type for period templates
         * @param {AddPeriodTemplateTagTypeRequest} addPeriodTemplateTagTypeRequest Tag type to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPeriodTemplateAllowedTagType: async (addPeriodTemplateTagTypeRequest: AddPeriodTemplateTagTypeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPeriodTemplateTagTypeRequest' is not null or undefined
            assertParamExists('addPeriodTemplateAllowedTagType', 'addPeriodTemplateTagTypeRequest', addPeriodTemplateTagTypeRequest)
            const localVarPath = `/period-templates/tag-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPeriodTemplateTagTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new period name template
         * @param {CreatePeriodTemplateRequest} createPeriodTemplateRequest New period template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPeriodTemplate: async (createPeriodTemplateRequest: CreatePeriodTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPeriodTemplateRequest' is not null or undefined
            assertParamExists('createPeriodTemplate', 'createPeriodTemplateRequest', createPeriodTemplateRequest)
            const localVarPath = `/period-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPeriodTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a tag_type from the period template allow-list
         * @param {string} tagTypeId ID of the tag type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodTemplateAllowedTagType: async (tagTypeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagTypeId' is not null or undefined
            assertParamExists('deletePeriodTemplateAllowedTagType', 'tagTypeId', tagTypeId)
            const localVarPath = `/period-templates/tag-types/{tagTypeId}`
                .replace(`{${"tagTypeId"}}`, encodeURIComponent(String(tagTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch delete period name templates
         * @param {Array<object>} requestBody Period template IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodTemplates: async (requestBody: Array<object>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deletePeriodTemplates', 'requestBody', requestBody)
            const localVarPath = `/period-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List tag_types permitted as attachments for period templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodTemplateAllowedTagTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/period-templates/tag-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all period name templates with tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodTemplates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/period-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a period name template\'s value and/or tags
         * @param {string} periodTemplateId ID of the period template
         * @param {UpdatePeriodTemplateRequest} updatePeriodTemplateRequest Fields to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeriodTemplate: async (periodTemplateId: string, updatePeriodTemplateRequest: UpdatePeriodTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodTemplateId' is not null or undefined
            assertParamExists('updatePeriodTemplate', 'periodTemplateId', periodTemplateId)
            // verify required parameter 'updatePeriodTemplateRequest' is not null or undefined
            assertParamExists('updatePeriodTemplate', 'updatePeriodTemplateRequest', updatePeriodTemplateRequest)
            const localVarPath = `/period-templates/{periodTemplateId}`
                .replace(`{${"periodTemplateId"}}`, encodeURIComponent(String(periodTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePeriodTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeriodTemplatesApi - functional programming interface
 * @export
 */
export const PeriodTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PeriodTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Permit an additional tag_type for period templates
         * @param {AddPeriodTemplateTagTypeRequest} addPeriodTemplateTagTypeRequest Tag type to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPeriodTemplateAllowedTagType(addPeriodTemplateTagTypeRequest: AddPeriodTemplateTagTypeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeriodTemplateAllowedTagType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPeriodTemplateAllowedTagType(addPeriodTemplateTagTypeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new period name template
         * @param {CreatePeriodTemplateRequest} createPeriodTemplateRequest New period template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPeriodTemplate(createPeriodTemplateRequest: CreatePeriodTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeriodTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPeriodTemplate(createPeriodTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a tag_type from the period template allow-list
         * @param {string} tagTypeId ID of the tag type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePeriodTemplateAllowedTagType(tagTypeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePeriodTemplateAllowedTagType(tagTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Batch delete period name templates
         * @param {Array<object>} requestBody Period template IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePeriodTemplates(requestBody: Array<object>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePeriodTemplates(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List tag_types permitted as attachments for period templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeriodTemplateAllowedTagTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PeriodTemplateAllowedTagType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeriodTemplateAllowedTagTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all period name templates with tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeriodTemplates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PeriodTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeriodTemplates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a period name template\'s value and/or tags
         * @param {string} periodTemplateId ID of the period template
         * @param {UpdatePeriodTemplateRequest} updatePeriodTemplateRequest Fields to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePeriodTemplate(periodTemplateId: string, updatePeriodTemplateRequest: UpdatePeriodTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeriodTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePeriodTemplate(periodTemplateId, updatePeriodTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PeriodTemplatesApi - factory interface
 * @export
 */
export const PeriodTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PeriodTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Permit an additional tag_type for period templates
         * @param {AddPeriodTemplateTagTypeRequest} addPeriodTemplateTagTypeRequest Tag type to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPeriodTemplateAllowedTagType(addPeriodTemplateTagTypeRequest: AddPeriodTemplateTagTypeRequest, options?: any): AxiosPromise<PeriodTemplateAllowedTagType> {
            return localVarFp.addPeriodTemplateAllowedTagType(addPeriodTemplateTagTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new period name template
         * @param {CreatePeriodTemplateRequest} createPeriodTemplateRequest New period template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPeriodTemplate(createPeriodTemplateRequest: CreatePeriodTemplateRequest, options?: any): AxiosPromise<PeriodTemplate> {
            return localVarFp.createPeriodTemplate(createPeriodTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a tag_type from the period template allow-list
         * @param {string} tagTypeId ID of the tag type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodTemplateAllowedTagType(tagTypeId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePeriodTemplateAllowedTagType(tagTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Batch delete period name templates
         * @param {Array<object>} requestBody Period template IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodTemplates(requestBody: Array<object>, options?: any): AxiosPromise<void> {
            return localVarFp.deletePeriodTemplates(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List tag_types permitted as attachments for period templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodTemplateAllowedTagTypes(options?: any): AxiosPromise<Array<PeriodTemplateAllowedTagType>> {
            return localVarFp.getPeriodTemplateAllowedTagTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all period name templates with tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodTemplates(options?: any): AxiosPromise<Array<PeriodTemplate>> {
            return localVarFp.getPeriodTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a period name template\'s value and/or tags
         * @param {string} periodTemplateId ID of the period template
         * @param {UpdatePeriodTemplateRequest} updatePeriodTemplateRequest Fields to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeriodTemplate(periodTemplateId: string, updatePeriodTemplateRequest: UpdatePeriodTemplateRequest, options?: any): AxiosPromise<PeriodTemplate> {
            return localVarFp.updatePeriodTemplate(periodTemplateId, updatePeriodTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeriodTemplatesApi - object-oriented interface
 * @export
 * @class PeriodTemplatesApi
 * @extends {BaseAPI}
 */
export class PeriodTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Permit an additional tag_type for period templates
     * @param {AddPeriodTemplateTagTypeRequest} addPeriodTemplateTagTypeRequest Tag type to add
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public addPeriodTemplateAllowedTagType(addPeriodTemplateTagTypeRequest: AddPeriodTemplateTagTypeRequest, options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).addPeriodTemplateAllowedTagType(addPeriodTemplateTagTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new period name template
     * @param {CreatePeriodTemplateRequest} createPeriodTemplateRequest New period template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public createPeriodTemplate(createPeriodTemplateRequest: CreatePeriodTemplateRequest, options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).createPeriodTemplate(createPeriodTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a tag_type from the period template allow-list
     * @param {string} tagTypeId ID of the tag type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public deletePeriodTemplateAllowedTagType(tagTypeId: string, options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).deletePeriodTemplateAllowedTagType(tagTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Batch delete period name templates
     * @param {Array<object>} requestBody Period template IDs to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public deletePeriodTemplates(requestBody: Array<object>, options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).deletePeriodTemplates(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List tag_types permitted as attachments for period templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public getPeriodTemplateAllowedTagTypes(options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).getPeriodTemplateAllowedTagTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all period name templates with tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public getPeriodTemplates(options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).getPeriodTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a period name template\'s value and/or tags
     * @param {string} periodTemplateId ID of the period template
     * @param {UpdatePeriodTemplateRequest} updatePeriodTemplateRequest Fields to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodTemplatesApi
     */
    public updatePeriodTemplate(periodTemplateId: string, updatePeriodTemplateRequest: UpdatePeriodTemplateRequest, options?: AxiosRequestConfig) {
        return PeriodTemplatesApiFp(this.configuration).updatePeriodTemplate(periodTemplateId, updatePeriodTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PeriodsApi - axios parameter creator
 * @export
 */
export const PeriodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Remove a tag from an athlete in a period
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodAthleteTags: async (periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('deletePeriodAthleteTags', 'periodId', periodId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('deletePeriodAthleteTags', 'athleteId', athleteId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('deletePeriodAthleteTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/periods/{periodId}/athletes/{athleteId}/tags`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)))
                .replace(`{${"athleteId"}}`, encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a tag from a period
         * @param {string} periodId ID of the period
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodTags: async (periodId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('deletePeriodTags', 'periodId', periodId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('deletePeriodTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/periods/{periodId}/tags`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to an athlete in a period
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodAthleteTags: async (periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('patchPeriodAthleteTags', 'periodId', periodId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('patchPeriodAthleteTags', 'athleteId', athleteId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('patchPeriodAthleteTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/periods/{periodId}/athletes/{athleteId}/tags`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)))
                .replace(`{${"athleteId"}}`, encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to multiple athletes in a period
         * @param {string} periodId ID of the period
         * @param {Array<PeriodAthleteTagNameBatchItem>} periodAthleteTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodAthleteTagsBatch: async (periodId: string, periodAthleteTagNameBatchItem: Array<PeriodAthleteTagNameBatchItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('patchPeriodAthleteTagsBatch', 'periodId', periodId)
            // verify required parameter 'periodAthleteTagNameBatchItem' is not null or undefined
            assertParamExists('patchPeriodAthleteTagsBatch', 'periodAthleteTagNameBatchItem', periodAthleteTagNameBatchItem)
            const localVarPath = `/periods/{periodId}/athletes/tags`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodAthleteTagNameBatchItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to a period
         * @param {string} periodId ID of the period
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodTags: async (periodId: string, entityTagNameRequest: EntityTagNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('patchPeriodTags', 'periodId', periodId)
            // verify required parameter 'entityTagNameRequest' is not null or undefined
            assertParamExists('patchPeriodTags', 'entityTagNameRequest', entityTagNameRequest)
            const localVarPath = `/periods/{periodId}/tags`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTagNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply a tag to multiple periods
         * @param {Array<PeriodTagNameBatchItem>} periodTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodTagsBatch: async (periodTagNameBatchItem: Array<PeriodTagNameBatchItem>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodTagNameBatchItem' is not null or undefined
            assertParamExists('patchPeriodTagsBatch', 'periodTagNameBatchItem', periodTagNameBatchItem)
            const localVarPath = `/periods/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodTagNameBatchItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit a period
         * @param {string} periodId ID of the period
         * @param {PeriodRequest} periodRequest Edit period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeriod: async (periodId: string, periodRequest: PeriodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('updatePeriod', 'periodId', periodId)
            // verify required parameter 'periodRequest' is not null or undefined
            assertParamExists('updatePeriod', 'periodRequest', periodRequest)
            const localVarPath = `/periods/{periodId}`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeriodsApi - functional programming interface
 * @export
 */
export const PeriodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PeriodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Remove a tag from an athlete in a period
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePeriodAthleteTags(periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePeriodAthleteTags(periodId, athleteId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a tag from a period
         * @param {string} periodId ID of the period
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePeriodTags(periodId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePeriodTags(periodId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to an athlete in a period
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPeriodAthleteTags(periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPeriodAthleteTags(periodId, athleteId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to multiple athletes in a period
         * @param {string} periodId ID of the period
         * @param {Array<PeriodAthleteTagNameBatchItem>} periodAthleteTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPeriodAthleteTagsBatch(periodId: string, periodAthleteTagNameBatchItem: Array<PeriodAthleteTagNameBatchItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPeriodAthleteTagsBatch(periodId, periodAthleteTagNameBatchItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to a period
         * @param {string} periodId ID of the period
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPeriodTags(periodId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPeriodTags(periodId, entityTagNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply a tag to multiple periods
         * @param {Array<PeriodTagNameBatchItem>} periodTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPeriodTagsBatch(periodTagNameBatchItem: Array<PeriodTagNameBatchItem>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPeriodTagsBatch(periodTagNameBatchItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Edit a period
         * @param {string} periodId ID of the period
         * @param {PeriodRequest} periodRequest Edit period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePeriod(periodId: string, periodRequest: PeriodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Period>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePeriod(periodId, periodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PeriodsApi - factory interface
 * @export
 */
export const PeriodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PeriodsApiFp(configuration)
    return {
        /**
         * 
         * @summary Remove a tag from an athlete in a period
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodAthleteTags(periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deletePeriodAthleteTags(periodId, athleteId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a tag from a period
         * @param {string} periodId ID of the period
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriodTags(periodId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deletePeriodTags(periodId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to an athlete in a period
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodAthleteTags(periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.patchPeriodAthleteTags(periodId, athleteId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to multiple athletes in a period
         * @param {string} periodId ID of the period
         * @param {Array<PeriodAthleteTagNameBatchItem>} periodAthleteTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodAthleteTagsBatch(periodId: string, periodAthleteTagNameBatchItem: Array<PeriodAthleteTagNameBatchItem>, options?: any): AxiosPromise<void> {
            return localVarFp.patchPeriodAthleteTagsBatch(periodId, periodAthleteTagNameBatchItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to a period
         * @param {string} periodId ID of the period
         * @param {EntityTagNameRequest} entityTagNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodTags(periodId: string, entityTagNameRequest: EntityTagNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.patchPeriodTags(periodId, entityTagNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply a tag to multiple periods
         * @param {Array<PeriodTagNameBatchItem>} periodTagNameBatchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPeriodTagsBatch(periodTagNameBatchItem: Array<PeriodTagNameBatchItem>, options?: any): AxiosPromise<void> {
            return localVarFp.patchPeriodTagsBatch(periodTagNameBatchItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit a period
         * @param {string} periodId ID of the period
         * @param {PeriodRequest} periodRequest Edit period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeriod(periodId: string, periodRequest: PeriodRequest, options?: any): AxiosPromise<Period> {
            return localVarFp.updatePeriod(periodId, periodRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeriodsApi - object-oriented interface
 * @export
 * @class PeriodsApi
 * @extends {BaseAPI}
 */
export class PeriodsApi extends BaseAPI {
    /**
     * 
     * @summary Remove a tag from an athlete in a period
     * @param {string} periodId ID of the period
     * @param {string} athleteId ID of the athlete
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public deletePeriodAthleteTags(periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).deletePeriodAthleteTags(periodId, athleteId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a tag from a period
     * @param {string} periodId ID of the period
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public deletePeriodTags(periodId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).deletePeriodTags(periodId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to an athlete in a period
     * @param {string} periodId ID of the period
     * @param {string} athleteId ID of the athlete
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public patchPeriodAthleteTags(periodId: string, athleteId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).patchPeriodAthleteTags(periodId, athleteId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to multiple athletes in a period
     * @param {string} periodId ID of the period
     * @param {Array<PeriodAthleteTagNameBatchItem>} periodAthleteTagNameBatchItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public patchPeriodAthleteTagsBatch(periodId: string, periodAthleteTagNameBatchItem: Array<PeriodAthleteTagNameBatchItem>, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).patchPeriodAthleteTagsBatch(periodId, periodAthleteTagNameBatchItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to a period
     * @param {string} periodId ID of the period
     * @param {EntityTagNameRequest} entityTagNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public patchPeriodTags(periodId: string, entityTagNameRequest: EntityTagNameRequest, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).patchPeriodTags(periodId, entityTagNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply a tag to multiple periods
     * @param {Array<PeriodTagNameBatchItem>} periodTagNameBatchItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public patchPeriodTagsBatch(periodTagNameBatchItem: Array<PeriodTagNameBatchItem>, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).patchPeriodTagsBatch(periodTagNameBatchItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit a period
     * @param {string} periodId ID of the period
     * @param {PeriodRequest} periodRequest Edit period
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeriodsApi
     */
    public updatePeriod(periodId: string, periodRequest: PeriodRequest, options?: AxiosRequestConfig) {
        return PeriodsApiFp(this.configuration).updatePeriod(periodId, periodRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RotationsApi - axios parameter creator
 * @export
 */
export const RotationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update rotations
         * @param {string} activityId ID of the activity
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {Array<Rotation>} rotation Update the athlete rotations for the period in the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRotations: async (activityId: string, periodId: string, athleteId: string, rotation: Array<Rotation>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('updateRotations', 'activityId', activityId)
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('updateRotations', 'periodId', periodId)
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('updateRotations', 'athleteId', athleteId)
            // verify required parameter 'rotation' is not null or undefined
            assertParamExists('updateRotations', 'rotation', rotation)
            const localVarPath = `/activities/{activityId}/periods/{periodId}/athletes/{athleteId}/rotations`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)))
                .replace(`{${"athleteId"}}`, encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rotation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RotationsApi - functional programming interface
 * @export
 */
export const RotationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RotationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update rotations
         * @param {string} activityId ID of the activity
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {Array<Rotation>} rotation Update the athlete rotations for the period in the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRotations(activityId: string, periodId: string, athleteId: string, rotation: Array<Rotation>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rotation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRotations(activityId, periodId, athleteId, rotation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RotationsApi - factory interface
 * @export
 */
export const RotationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RotationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Update rotations
         * @param {string} activityId ID of the activity
         * @param {string} periodId ID of the period
         * @param {string} athleteId ID of the athlete
         * @param {Array<Rotation>} rotation Update the athlete rotations for the period in the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRotations(activityId: string, periodId: string, athleteId: string, rotation: Array<Rotation>, options?: any): AxiosPromise<Array<Rotation>> {
            return localVarFp.updateRotations(activityId, periodId, athleteId, rotation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RotationsApi - object-oriented interface
 * @export
 * @class RotationsApi
 * @extends {BaseAPI}
 */
export class RotationsApi extends BaseAPI {
    /**
     * 
     * @summary Update rotations
     * @param {string} activityId ID of the activity
     * @param {string} periodId ID of the period
     * @param {string} athleteId ID of the athlete
     * @param {Array<Rotation>} rotation Update the athlete rotations for the period in the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RotationsApi
     */
    public updateRotations(activityId: string, periodId: string, athleteId: string, rotation: Array<Rotation>, options?: AxiosRequestConfig) {
        return RotationsApiFp(this.configuration).updateRotations(activityId, periodId, athleteId, rotation, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all non-readonly tags with their tag type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all non-readonly tags with their tag type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all non-readonly tags with their tag type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options?: any): AxiosPromise<Array<TagResponse>> {
            return localVarFp.getTags(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
    /**
     * 
     * @summary Get all non-readonly tags with their tag type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public getTags(options?: AxiosRequestConfig) {
        return TagsApiFp(this.configuration).getTags(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebEditorApi - axios parameter creator
 * @export
 */
export const WebEditorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new annotation
         * @param {string} activityId ID of the activity
         * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotation: async (activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('createAnnotation', 'activityId', activityId)
            // verify required parameter 'annotationRequestWithLayerId' is not null or undefined
            assertParamExists('createAnnotation', 'annotationRequestWithLayerId', annotationRequestWithLayerId)
            const localVarPath = `/activities/{activityId}/annotations`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationRequestWithLayerId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotationLayer: async (annotationLayerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationLayerId' is not null or undefined
            assertParamExists('deleteAnnotationLayer', 'annotationLayerId', annotationLayerId)
            const localVarPath = `/annotation_layers/{annotationLayerId}`
                .replace(`{${"annotationLayerId"}}`, encodeURIComponent(String(annotationLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple annotations in a single request
         * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotations: async (batchDeleteRequest: BatchDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchDeleteRequest' is not null or undefined
            assertParamExists('deleteAnnotations', 'batchDeleteRequest', batchDeleteRequest)
            const localVarPath = `/annotations/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayersForActivity: async (activityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getAnnotationLayersForActivity', 'activityId', activityId)
            const localVarPath = `/activities/{activityId}/annotation_layers`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an annotation
         * @param {string} annotationId ID of the annotation
         * @param {AnnotationRequest} annotationRequest Updated annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotation: async (annotationId: string, annotationRequest: AnnotationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'annotationId' is not null or undefined
            assertParamExists('updateAnnotation', 'annotationId', annotationId)
            // verify required parameter 'annotationRequest' is not null or undefined
            assertParamExists('updateAnnotation', 'annotationRequest', annotationRequest)
            const localVarPath = `/annotations/{annotationId}`
                .replace(`{${"annotationId"}}`, encodeURIComponent(String(annotationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebEditorApi - functional programming interface
 * @export
 */
export const WebEditorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebEditorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new annotation
         * @param {string} activityId ID of the activity
         * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnotation(activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Annotation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnotation(activityId, annotationRequestWithLayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnotationLayer(annotationLayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete multiple annotations in a single request
         * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnotations(batchDeleteRequest: BatchDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnotations(batchDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnotationLayersForActivity(activityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnotationLayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnotationLayersForActivity(activityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an annotation
         * @param {string} annotationId ID of the annotation
         * @param {AnnotationRequest} annotationRequest Updated annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnotation(annotationId: string, annotationRequest: AnnotationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Annotation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnotation(annotationId, annotationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebEditorApi - factory interface
 * @export
 */
export const WebEditorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebEditorApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new annotation
         * @param {string} activityId ID of the activity
         * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnotation(activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options?: any): AxiosPromise<Annotation> {
            return localVarFp.createAnnotation(activityId, annotationRequestWithLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an annotation layer and all its annotations
         * @param {string} annotationLayerId ID of the annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotationLayer(annotationLayerId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAnnotationLayer(annotationLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple annotations in a single request
         * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnotations(batchDeleteRequest: BatchDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAnnotations(batchDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annotation layers for an activity
         * @param {string} activityId ID of the activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnotationLayersForActivity(activityId: string, options?: any): AxiosPromise<Array<AnnotationLayer>> {
            return localVarFp.getAnnotationLayersForActivity(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an annotation
         * @param {string} annotationId ID of the annotation
         * @param {AnnotationRequest} annotationRequest Updated annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnotation(annotationId: string, annotationRequest: AnnotationRequest, options?: any): AxiosPromise<Annotation> {
            return localVarFp.updateAnnotation(annotationId, annotationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebEditorApi - object-oriented interface
 * @export
 * @class WebEditorApi
 * @extends {BaseAPI}
 */
export class WebEditorApi extends BaseAPI {
    /**
     * 
     * @summary Create a new annotation
     * @param {string} activityId ID of the activity
     * @param {AnnotationRequestWithLayerId} annotationRequestWithLayerId New annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebEditorApi
     */
    public createAnnotation(activityId: string, annotationRequestWithLayerId: AnnotationRequestWithLayerId, options?: AxiosRequestConfig) {
        return WebEditorApiFp(this.configuration).createAnnotation(activityId, annotationRequestWithLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an annotation layer and all its annotations
     * @param {string} annotationLayerId ID of the annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebEditorApi
     */
    public deleteAnnotationLayer(annotationLayerId: string, options?: AxiosRequestConfig) {
        return WebEditorApiFp(this.configuration).deleteAnnotationLayer(annotationLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple annotations in a single request
     * @param {BatchDeleteRequest} batchDeleteRequest Annotation IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebEditorApi
     */
    public deleteAnnotations(batchDeleteRequest: BatchDeleteRequest, options?: AxiosRequestConfig) {
        return WebEditorApiFp(this.configuration).deleteAnnotations(batchDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annotation layers for an activity
     * @param {string} activityId ID of the activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebEditorApi
     */
    public getAnnotationLayersForActivity(activityId: string, options?: AxiosRequestConfig) {
        return WebEditorApiFp(this.configuration).getAnnotationLayersForActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an annotation
     * @param {string} annotationId ID of the annotation
     * @param {AnnotationRequest} annotationRequest Updated annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebEditorApi
     */
    public updateAnnotation(annotationId: string, annotationRequest: AnnotationRequest, options?: AxiosRequestConfig) {
        return WebEditorApiFp(this.configuration).updateAnnotation(annotationId, annotationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


